import { getType } from 'typesafe-actions'
import {
  KommuneresultatAction,
  fetchActions,
  resetKommuneresultat
} from '../actions/kommuneresultat'
import { ResultsState, PageState } from '../state'
import { isValidError, isValidResult } from '../helpers'

type KommuneresultaterReducer = (
  state: ResultsState,
  action: KommuneresultatAction,
  page: PageState
) => ResultsState

export const defaultKommuneresultat: ResultsState = {
  state: 'empty'
}

export const kommuneresultatReducer: KommuneresultaterReducer = (
  currentResultState = defaultKommuneresultat,
  action,
  page
) => {
  switch (action.type) {
    case getType(resetKommuneresultat):
      return {
        state: 'empty'
      }
    case getType(fetchActions.request):
      if (action.payload === 'RELOAD' && 'data' in currentResultState) {
        return {
          state: 'reloading',
          data: currentResultState.data
        }
      } else {
        return {
          state: 'loading'
        }
      }
    case getType(fetchActions.success):
      // The user might have reloaded before the request has resolved.
      // If that is the case we need to discard the result.
      if (isValidResult(action.payload, page.current, 'ko')) {
        if (action.payload.resultsLocked) {
          return { state: 'locked' }
        } else {
          return {
            state: 'success',
            data: action.payload
          }
        }
      } else {
        return currentResultState
      }

    case getType(fetchActions.failure):
      if (isValidError(action.payload, page.current, 'ko')) {
        if (currentResultState.state === 'reloading') {
          return {
            ...currentResultState,
            state: 'success'
          }
        }
        return {
          state: 'error',
          error: action.payload.error
        }
      } else {
        return currentResultState
      }

    default:
      return currentResultState
  }
}
